import { render, staticRenderFns } from "./ModalPilihAnggota.vue?vue&type=template&id=ef0571f6&scoped=true&"
import script from "./ModalPilihAnggota.vue?vue&type=script&lang=js&"
export * from "./ModalPilihAnggota.vue?vue&type=script&lang=js&"
import style0 from "./ModalPilihAnggota.vue?vue&type=style&index=0&id=ef0571f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0571f6",
  null
  
)

export default component.exports